module.exports = {
  line_items: [
    {
      lead_times: [8],
      pricing   : [
        [0],
        [0],
        [0],
        [0],
      ],
      quantities: [10, 25, 50, 100],
    },
  ],
};
